const makeConstant = constant => `AF_/${constant}`

export const FETCH_ARTICLE_FEEDBACK_REPORT = makeConstant('FETCH_ARTICLE_FEEDBACK_REPORT')
export const FETCH_ARTICLE_FEEDBACK_REPORT_PENDING = makeConstant('FETCH_ARTICLE_FEEDBACK_REPORT_PENDING')
export const FETCH_ARTICLE_FEEDBACK_REPORT_SUCCESS = makeConstant('FETCH_ARTICLE_FEEDBACK_REPORT_SUCCESS')
export const FETCH_ARTICLE_FEEDBACK_REPORT_FAILED = makeConstant('FETCH_ARTICLE_FEEDBACK_REPORT_FAILED')